import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { Costanti, CostantiStorage } from '../costanti';
import { Utils } from '../utils';

@Injectable()
export class UtentiService {
  private BASEURL = Costanti.APIURL + 'utenti/';

  protected loadingSubject = new BehaviorSubject(false);
  loading$ = this.loadingSubject.asObservable();

  constructor(private http: HttpClient) {}

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error); // log to console instead
      console.log(`${operation} failed: ${error.message}`);
      return of(result as T);
    };
  }

  private extractData(res) {
    return res['data'] || {};
  }
  private extractDataLogin(res) {
    // console.log(res);
    if (res.data && res.data.token) {
      localStorage.setItem(CostantiStorage.TOKEN, res.data.token);
      // localStorage.setItem(CostantiStorage.TOKENPASS, res.data.tokenpass);
    }
    return res['data'] || {};
  }
  logout() {
    this.loadingSubject.next(true);
    const body = {};
    const url = this.BASEURL + 'logout';
    return this.http.post(url, body).pipe(
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => {
        this.loadingSubject.next(false);
      })
    );
  }
  checkSession() {
    this.loadingSubject.next(true);
    const body = {};
    const url = this.BASEURL + 'check-session';
    return this.http.post(url, body).pipe(
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => {
        this.loadingSubject.next(false);
      })
    );
  }
  logError(error): Promise<JSON> {
    const body = { error };
    this.loadingSubject.next(true);
    return this.http
      .post(this.BASEURL + 'log-error', body)
      .pipe(
        ////retry(3),
        map(this.extractData),
        catchError(this.handleError<JSON>(this.BASEURL + 'log-error')),
        finalize(() => {
          this.loadingSubject.next(false);
        })
      )
      .toPromise();
  }
  // logTool(): Observable<JSON> {
  //   const body = {};
  //   // console.log(body);
  //   const url = this.BASEURL + 'log';
  //   return this.http
  //     .post(url, body, {
  //       // observe: 'response',
  //       // withCredentials: true
  //     })
  //     .pipe(
  //       //retry(3),
  //       map(this.extractData),
  //       catchError(this.handleError<JSON>(url)),
  //       finalize(() => {
  //         this.loadingSubject.next(false);
  //       })
  //     );
  // }
  updateShowBannerFondazione() {
    const body = {};
    // console.log(body);
    const url = this.BASEURL + 'update-show-banner-fondazione-ser';
    return this.http
      .post(url, body)
      .pipe(
        ////retry(3),
        map(this.extractData),
        catchError(this.handleError<JSON>(url)),
        finalize(() => {
          this.loadingSubject.next(false);
        })
      )
      .toPromise();
  }
  loginNew(username, password): Observable<JSON> {
    const body = { username: username, psw: Utils.SHA256(password).toString(), host: 'ser' };
    // console.log(body);
    this.loadingSubject.next(true);
    const url = this.BASEURL + 'login-new';
    return this.http
      .post(url, body, {
        // observe: 'response',
        // withCredentials: true
      })
      .pipe(
        //retry(3),
        map(this.extractDataLogin),
        catchError(this.handleError<JSON>(url, {} as JSON)),
        finalize(() => {
          this.loadingSubject.next(false);
        })
      );
  }
  switchPreLogin(email?) {
    const body = { email };
    // console.log(body);
    const url = this.BASEURL + 'switch-login';
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => {
        this.loadingSubject.next(false);
      })
    );
  }
  preLogin(token_switch) {
    const body = { token_switch };
    // console.log(body);
    const url = this.BASEURL + 'pre-login';
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => {
        this.loadingSubject.next(false);
      })
    );
  }
  postPrimoLogin(email, password_temp, password) {
    const body = {
      email,
      password_temp: Utils.SHA256(password_temp).toString(),
      password: Utils.SHA256(password).toString()
    };
    // console.log(body);
    this.loadingSubject.next(true);
    const url = this.BASEURL + 'post-primo-login';
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => {
        this.loadingSubject.next(false);
      })
    );
  }
  getTipoUtenza() {
    const body = {};
    // console.log(body);
    const url = this.BASEURL + 'tipo-utenza';
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => {
        this.loadingSubject.next(false);
      })
    );
  }
  getUtente() {
    const body = {};
    const url = this.BASEURL + 'utente';
    this.loadingSubject.next(true);
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => {
        this.loadingSubject.next(false);
      })
    );
  }
  getMenu() {
    const body = {};
    const url = this.BASEURL + 'menu-servizi';
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => {
        this.loadingSubject.next(false);
      })
    );
  }
  richiestaRecuperoPsw(email): Observable<JSON> {
    const body = { email };
    // console.log(body);
    this.loadingSubject.next(true);
    const url = this.BASEURL + 'richiesta-recupero-password';
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractDataLogin),
      catchError(this.handleError<JSON>(url)),
      finalize(() => {
        this.loadingSubject.next(false);
      })
    );
  }
  recuperaPassword(token, email, password): Observable<JSON> {
    const body = { token, email, password: Utils.SHA256(password).toString() };
    // console.log(body);
    this.loadingSubject.next(true);
    const url = this.BASEURL + 'recupero-password';
    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractDataLogin),
      catchError(this.handleError<JSON>(url)),
      finalize(() => {
        this.loadingSubject.next(false);
      })
    );
  }

  setAccettazionePrivacy(): Observable<JSON> {
    const body = {};
    this.loadingSubject.next(true);
    const url = this.BASEURL + 'set-accettazione-privacy-servizi';
    return this.http.post(url, body).pipe(
      ////retry(3),
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => {
        this.loadingSubject.next(false);
      })
    );
  }
  getNomeSezione(idSezione) {
    const body = { idSezione: idSezione };
    // console.log(body);
    this.loadingSubject.next(true);
    const url = this.BASEURL + 'get-nome-sezione-ser';
    return this.http
      .post(url, body)
      .pipe(
        ////retry(3),
        map(this.extractDataLogin),
        catchError(this.handleError<JSON>(url)),
        finalize(() => {
          this.loadingSubject.next(false);
        })
      )
      .toPromise();
  }
  getOAuthCode(idSezione) {
    const body = { idSezione: idSezione, term: 'shop' };
    // console.log(body);
    this.loadingSubject.next(true);
    const url = this.BASEURL + 'get-oauth-code-ser';
    return this.http
      .post(url, body)
      .pipe(
        ////retry(3),
        map(this.extractDataLogin),
        catchError(this.handleError<JSON>(url)),
        finalize(() => {
          this.loadingSubject.next(false);
        })
      )
      .toPromise();
  }
  aggiornaDataUltimoCheckAnagrafica() {
    const url = this.BASEURL + 'aggiorna-data-ultimo-check-anagrafica';
    return this.http.post(url, {}).pipe(
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => {
        this.loadingSubject.next(false);
      })
    );
  }
  aggiornaTipoUtenteInNonSocio() {
    const url = this.BASEURL + 'aggiorna-tipo-utente-non-socio';
    return this.http.post(url, {}).pipe(
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => {
        this.loadingSubject.next(false);
      })
    );
  }
  verificaDatiAnagrafici() {
    const url = this.BASEURL + 'verifica-i-miei-dati-anagrafici';
    return this.http.post(url, {}).pipe(
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => {
        this.loadingSubject.next(false);
      })
    );
  }
  aggiornaDatiAnagrafici(payload: {
    codice_fiscale: string;
    partita_iva: string;
    codice_destinatario: string;
    pec: string;
    via: string;
    cap: string;
    id_comune: string;
  }) {
    const url = this.BASEURL + 'aggiorna-dati-anagrafici';
    return this.http.post(url, payload).pipe(
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => {
        this.loadingSubject.next(false);
      })
    );
  }
  uploadFotoProfilo(formData: FormData): Observable<unknown> {
    this.loadingSubject.next(true);
    return this.http.post(Costanti.APIURL + 'utenti/salva-img-profilo', formData).pipe(
      finalize(() => {
        this.loadingSubject.next(false);
      })
    );
  }

  eliminaFotoProfilo(): Observable<unknown> {
    const formData = new FormData();
    formData.append('file', '');
    return this.uploadFotoProfilo(formData);
  }
  // login(username, password): Observable<JSON> {
  //   const body = { username: username, psw: Utils.SHA256(password).toString() };
  //   // console.log(body);
  //   const url = this.BASEURL + 'login';
  //   return this.http.post(url, body).pipe(
  //     //retry(3),
  //     map(this.extractDataLogin),
  //     catchError(this.handleError<JSON>(url)),
  //     finalize(() => {
  //       this.loadingSubject.next(false);
  //     })
  //   );
  // }
  // firebase(token): Observable<JSON> {
  //   const body = { token: token };
  //   // console.log(body);
  //   const url = this.BASEURL + 'login-fire';
  //   return this.http.post(url, body).pipe(
  //     //retry(3),
  //     map(this.extractDataLogin),
  //     catchError(this.handleError<JSON>(url)),
  //     finalize(() => {
  //       this.loadingSubject.next(false);
  //     })
  //   );
  // }
}
